import captionService from "CaptionService";

export const themeConfiguration: { [key: string]: () => string } = {
  close: (): string => captionService.getString("e11f9410-ce63-4603-a4ca-1e3e1a781716", "Close"),
  color: (): string => captionService.getString("57135ef4-7de6-49cc-a0f0-2c2e7652032d", "Color"),
  colors: (): string => captionService.getString("f796dffb-d4b1-4298-92d3-cc098996780d", "Colors"),
  contentBackground: (): string =>
    captionService.getString("ad69163f-b1e7-4552-85d8-cd34d2a12083", "Content Background"),
  copyThemeFrom: (): string => captionService.getString("b72d209f-99ef-4009-aa6f-4cb2090ec905", "Copy theme from"),
  dark: (): string => captionService.getString("31f1a5bd-9860-4023-b708-e9aa051fed3d", "Dark"),
  portal: (): string => captionService.getString("decb220b-eaeb-47e9-b7ae-db8f28c56c0e", "Portal"),
  primary: (): string => captionService.getString("4ac084c5-5a53-461c-a3a2-cc3f2e04b09e", "Primary"),
  brand: (): string => captionService.getString("21a47707-bcd8-4902-bfc5-db50d2720ab6", "Brand"),
  lightTheme: (): string => captionService.getString("8bb3bce1-6864-442b-b02d-33c826b792b6", "Light theme"),
  darkTheme: (): string => captionService.getString("e6d60800-dd6c-4c0a-8d75-972f6e947425", "Dark theme"),
  logo: (): string => captionService.getString("989233b0-bb6c-423b-a066-7801ce0eafc4", "Logo"),
  logoColor: (): string => captionService.getString("991f729f-395a-4fc9-93df-8e27bec046f5", "Logo background"),
  logoDarkDescription: (): string => captionService.getString("0cbdde16-9080-438e-ac5f-1506c1e4cc24", "Dark logo"),
  logoLightDescription: (): string => captionService.getString("c0759b34-d63a-45aa-9fb5-8431479296a2", "Light logo"),
  logos: (): string => captionService.getString("41302576-58a7-41ec-af67-02f0bdb31d29", "Logos"),
  manageExistingThemes: (): string =>
    captionService.getString("cace5d43-5338-4ef8-b90b-44e69ff1f8dd", "Manage existing themes"),
  brandLogin: (): string => captionService.getString("ed92629d-a813-4803-adaa-731522f1e52e", "Login logo background"),
  reset: (): string => captionService.getString("7a3460f2-de9d-412f-833f-b0e5b88eec85", "Reset"),
  save: (): string => captionService.getString("56bf844c-4fa8-4de8-bd85-a4a9b7ff989f", "Save"),
  back: (): string => captionService.getString("f3641657-cd70-4742-a43a-d4355526a655", "Back"),
  select: (): string => captionService.getString("fdf7b6e9-03c5-4c32-a284-9441294f73b4", "Select logo"),
  title: (): string => captionService.getString("a0a8cf66-1b53-4521-be7e-ec04d84fbe70", "Theme configuration"),
  presets: (): string => captionService.getString("9f2cc88a-66be-47a2-a133-81416e2c33e3", "Themes"),
  themeColors: (): string => captionService.getString("a4f844d7-ed87-4787-8941-7b5f90d116f2", "Theme colors"),
  fileSizeTooLarge: (): string =>
    captionService.getString("5074930f-3edb-422d-ba95-ecda45566718", "File size exceeds the maximum limit of 500KB."),
  themeName: (): string => captionService.getString("e40f0c23-88d8-4345-9eac-299a2be69a4e", "Theme name"),
  systemThemeName: (): string =>
    captionService.getString("df182905-e187-45a7-b44a-dac6ece0255b", "CargoWise default theme"),
  newTheme: (): string => captionService.getString("84d498b6-3e5f-49c9-8512-e3de60965102", "New theme"),
  editTheme: (): string => captionService.getString("46f3fda0-df2d-4cef-8faf-6d655a618979", "Edit theme"),
  configureBy: (): string => captionService.getString("205bf8f1-5a1a-46d2-a713-2192a699b884", "Configure by"),
  hostname: (): string => captionService.getString("97b4b6f9-1562-4b6f-841b-ba9dc4bceffe", "Hostname"),
  organization: (): string => captionService.getString("99cb2ec7-ea77-409d-826b-fe43b04fcce8", "Organization"),
  company: (): string => captionService.getString("5084e95b-ea46-4d07-8edb-198bc1d68423", "Company"),
  branch: (): string => captionService.getString("486089fc-b55d-449f-900f-3a3efb0fe267", "Branch"),
  department: (): string => captionService.getString("90c801f6-1291-4cb9-9776-76c35256d533", "Department"),
  configureTheme: (): string => captionService.getString("0af2b62f-eda6-4448-a97d-4466fefe1e4d", "Configure theme"),
  createNewTheme: (): string => captionService.getString("99699707-ccf4-4afd-a088-fe3421c9fdb6", "Create new theme"),
  saveTheme: (): string => captionService.getString("be259ff8-989e-4d54-ba69-be8e24890fbd", "Save theme"),
  userContact: (): string => captionService.getString("41849237-79d5-438f-b678-b39944facfac", "User - Contact"),
  userStaff: (): string => captionService.getString("0d2e778c-c5b4-4263-bbc0-329b8520295b", "User - Staff"),
  textColor: (): string => captionService.getString("662a441c-2cbe-43fc-80a9-38a0d6afd588", "Text color"),
  whiteText: (): string => captionService.getString("9f48a594-23c6-41cd-8530-c00a984f381c", "White"),
  blackText: (): string => captionService.getString("a9a05aee-b887-4c22-9824-2f7029b97158", "Black"),
  upload: (): string => captionService.getString("6478f395-811f-402d-a02e-1346be6db8df", "Upload"),
  navigation: (): string => captionService.getString("a9f2bbb0-1517-4517-9bcf-82ef5964be5e", "Navigation"),
  createdTime: (): string => captionService.getString("7ee471b5-2886-48b2-8017-03ffd8d7cbc2", "Created time"),
  createdUser: (): string => captionService.getString("2547a213-7e98-4f66-b55a-6370634259d8", "Created by staff"),
  lastEditTime: (): string => captionService.getString("dfaeb017-a135-472e-80d1-0a9b819eae72", "Last edited time"),
  lastEditUser: (): string => captionService.getString("1415a668-0261-4ce2-8824-dd3010d54108", "Last edited by staff"),
  themeNameIsRequired: (): string =>
    captionService.getString("e0deeea2-ef34-4120-ab5d-ea0d4c903650", "Theme name is required."),
  configureByIsRequired: (): string =>
    captionService.getString("793e17e2-4156-4753-8591-bf2b3d9090cc", "Configure by is required."),
  portalIsRequired: (): string =>
    captionService.getString("bace93aa-7bbc-4cd4-8a40-f4e251a74bd5", "Portal is required."),
  hostnameIsRequired: (): string =>
    captionService.getString("6455731f-ccc2-42cf-a82d-c6ab04f390ee", "Hostname is required."),
  hostnameIsInvalid: (): string =>
    captionService.getString(
      "d767b05d-d751-4d12-9b41-a78bc8834b52",
      "Please enter the domain name only, for example: 'domain.com'.",
    ),
  organizationIsRequired: (): string =>
    captionService.getString("0f494711-0904-4f72-8d0e-20aae6be9772", "Organization is required."),
  staffConfigIsRequired: (): string =>
    captionService.getString("ade4efbd-1d38-4ae4-8a0d-32e68866fbb2", "Please select at least a Company or Department."),
  duplicatedThemeName: (): string =>
    captionService.getString(
      "de351ea9-7435-4539-9aac-19292731accd",
      "A theme exists with the same name, please change the theme name and try again.",
    ),
  duplicatedThemeConfiguration: (): string =>
    captionService.getString(
      "919d34d9-ab49-439d-819e-4be427092774",
      "A theme against the same configuration already exists, click 'Save' to override the existing.",
    ),
  warning: (): string => captionService.getString("0ad6c9c7-a6d8-4310-b0d2-880e6f5909b4", "Warning"),
  failed: (): string => captionService.getString("a486cc97-d8a1-4ffa-9db7-437ae28330aa", "Failed"),
  generalThemeSavingError: (): string =>
    captionService.getString(
      "be8ead57-63a8-4ca7-92dd-7897d3028f2c",
      "This theme cannot be saved right now, please try again later.",
    ),
};
